const DEBUG_CONFIG = {
  fpsMeter: false,
  rendererStats: false,
  gridHelper: false,
  modeWithoutUI: false,
  skipIntro: false,
};

export default DEBUG_CONFIG;
